import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';
import Requirement from '@/views/requirement/index.vue';

const requirementRouter: RouteConfig = {
    path: '/requirement',
    component: Layout,
    redirect: '/requirement/index',
    children: [
      {
        path: '/requirement/index',
        name: 'Requirement',
        component: Requirement,
        meta: {
          title: 'route.requirement',
          icon: 'iconxuqiu',
          activeMenu: ['/requirement/index'],
          breadcrumb: [
            {title: 'route.requirementList', path: '/requirement/index'},
          ],
        },
      },
      {
        path: '/requirement/create',
        name: 'CreateRequirement',
        component: () => import('@/views/requirement/createRequirement.vue'),
        meta: {
          hidden: true,
          activeMenu: ['/requirement/index'],
          title: 'route.createRequirement',
          noCache: true,
          breadcrumb: [
            {title: 'route.requirementList', path: '/requirement/index'},
            {title: 'route.createRequirement', path: '/requirement/create'},
          ],
        },
      },
      {
        path: '/requirement/update',
        name: 'UpdateRequirement',
        component: () => import('@/views/requirement/updateRequirement.vue'),
        meta: {
          hidden: true,
          activeMenu: ['/requirement/index'],
          title: 'route.updateRequirement',
          noCache: true,
          breadcrumb: [
            {title: 'route.requirementList', path: '/requirement/index'},
            {title: 'route.updateRequirement', path: '/requirement/update'},
          ],
        },
      },
    ],
};

export default requirementRouter;
